module.exports = __webpack_public_path__ + "img/aogs-banner.c1563aec.jpg";